/**
 * Created by renjie.huang on 2017/11/6.
 */

module.exports = function() {
    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4())+'@picture_code';
};


// WEBPACK FOOTER //
// src/common/uuid.js